export default __webpack_public_path__ + "media/zurb/img/design-systems/components_library-78b7004d0571dd47ba62943b5378a84a.png";